import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import './Cart.css';

function Cart({ toggleCart }) {
  const { cartItems, removeFromCart, updateQuantity, getCartTotal } = useCart();
  const navigate = useNavigate();

  const handleCheckout = () => {
    toggleCart();
    navigate('/checkout-delivery');
  };

  return (
    <>
      <div className="cart-header">
        <h2>Carrito de Compras</h2>
        <button className="close-cart-btn" onClick={toggleCart}>&times;</button>
      </div>
      {cartItems.length === 0 ? (
        <p className="empty-cart-message">Tu carrito está vacío.</p>
      ) : (
        <>
          <div className="cart-items">
            {cartItems.map(item => (
              <div key={item.id} className="cart-item">
                <div className="cart-item-info">
                  <h3>{item.name}</h3>
                  <p>Precio: ${item.price}</p>
                </div>
                <div className="cart-item-actions">
                  <input 
                    type="number" 
                    value={item.quantity}
                    onChange={(e) => updateQuantity(item.id, parseInt(e.target.value))}
                    min="1"
                  />
                  <button onClick={() => removeFromCart(item.id)}>Eliminar</button>
                </div>
              </div>
            ))}
          </div>
          <div className="cart-total">
            <h3>Total: ${getCartTotal()}</h3>
            <button onClick={handleCheckout}>Proceder al Pago</button>
          </div>
        </>
      )}
    </>
  );
}

export default Cart;
